import _ from 'lodash'
import type {CoreExportFormat} from '@wix/document-services-types'
import {decorationPlugins} from './decorations'
import type {DecorationPlugin, DecorationPluginFunction, DecorationPluginUtils} from './types'

const packPlugins: DecorationPlugin[] = [...decorationPlugins]
const unpackPlugins: DecorationPlugin[] = _.reverse([...packPlugins])

const runPlugins = (
    plugins: DecorationPlugin[],
    componentExport: CoreExportFormat,
    utils: DecorationPluginUtils,
    getPluginFuncToRun: (plugin: DecorationPlugin) => DecorationPluginFunction | undefined
) => {
    for (const plugin of plugins) {
        const pluginFunc = getPluginFuncToRun(plugin)
        pluginFunc?.(componentExport, utils)
    }
}

export const getPluginsRunner = (componentExport: CoreExportFormat, {nicknameGenerator}: DecorationPluginUtils) => ({
    pack: () => runPlugins(packPlugins, componentExport, {nicknameGenerator}, p => p.pack),
    unpack: () => runPlugins(unpackPlugins, componentExport, {nicknameGenerator}, p => p.unpack)
})
